if (!customElements.get('cr-testimonial-feature')) {
  customElements.define('cr-testimonial-feature', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      const next = this.querySelector('[data-next]');
      if (next) {
        next.hidden = this.slides.length < 2;
        next.addEventListener('click', () => {
          this.show(this.index + 1);
          const status = this.querySelector('[data-status]');
          if (status) status.textContent = `Testimonial ${this.index + 1} of ${this.slides.length}: ${this.slides[this.index].querySelector('figcaption')?.textContent || ''}`;
          this.sync();
        }, options);
      }
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', () => this.sync(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.contains(event.target));
        if (index >= 0) { this.show(index); this.stop(); }
      }, options);
      this.resize = new ResizeObserver(() => this.fit());
      this.resize.observe(this);
      document.fonts.ready.then(() => { if (this.isConnected) this.fit(); });
      this.show(0);
      this.sync();
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = index % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.fit();
    }
    fit() {
      const copy = this.slides[this.index]?.querySelector('figure');
      if (!copy) return;
      const quote = copy.querySelector('blockquote');
      quote.style.removeProperty('font-size');
      const style = getComputedStyle(copy);
      const available = copy.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom) - parseFloat(style.rowGap) - copy.querySelector('figcaption').offsetHeight;
      let size = parseFloat(getComputedStyle(quote).fontSize);
      while (quote.offsetHeight > available && size > 14) {
        size -= 0.5;
        quote.style.fontSize = `${size}px`;
      }
    }
    stop() { clearInterval(this.timer); }
    sync() {
      this.stop();
      if (this.slides.length > 1 && this.dataset.rotate === 'true' && !this.motion.matches && !document.hidden) {
        this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.interval || 20) * 1000);
      }
    }
    disconnectedCallback() { this.stop(); this.abort?.abort(); this.resize?.disconnect(); }
  });
}
